// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollUpButton--scroll--1BMGT"};